import React from 'react'
import { Nav, Navbar, NavDropdown, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

import logoBlack from '../assets/Logo-black-1.svg'
import { AppDispatch } from '../store'
import { logout } from '../store/authSlice'
import { RootState } from '../store/rootReducer'

const VsNavbar = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation('navbar')
  const { currentUser } = useSelector((state: RootState) => state.auth)

  return (
    <Navbar bg="white" expand="lg" style={{ backgroundColor: '#ffffff !important' }}>
      <Container>
        <Link className="navbar-brand" to="/">
          <img className="d-inline-block align-top mr-2" src={logoBlack} alt="Vinnuskóli" height="30" />
          <span style={{ textTransform: 'uppercase', fontSize: '11px' }}>Vinnuskóli</span>
        </Link>
        <Navbar.Toggle aria-controls="vinnuskoli-umsokn-navbar" />
        <Navbar.Collapse id="vinnuskoli-umsokn-navbar">
          <Nav className="mr-auto">
            <NavLink to="/" exact className="nav-link">
              {t('yfirlit')}
            </NavLink>
            <NavLink to="/umsoknir" className="nav-link">
              {t('umsoknir')}
            </NavLink>
            <NavLink to="/skraningar" className="nav-link">
              {t('skraningar')}
            </NavLink>
            <NavLink to="/skraumsokn" className="nav-link">
              {t('skraUmsokn')}
            </NavLink>
          </Nav>
          <Nav>
            {currentUser && (
              <NavDropdown title={currentUser.name} id="vinnuskoli-user-dropdown">
                <NavDropdown.Item
                  href="#utskra"
                  onClick={(e) => {
                    e.preventDefault()
                    dispatch(logout()).finally(() => {
                      window.location.href = '/'
                    })
                  }}
                >
                  {t('utskra')}
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default VsNavbar
